import { Node, mergeAttributes } from '@tiptap/core';
import {
  ReactNodeViewRenderer,
  NodeViewWrapper,
  NodeViewContent,
} from '@tiptap/react';
import MuiButton from '@mui/material/Button';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    'mui-button': {
      /**
       * Toggle a link mark
       */
      setButton: (options: { href: string }) => ReturnType;
      unsetButton: () => ReturnType;
    };
  }

  interface NodeViewProps {}
}

type ComponentProps = {
  node: {
    attrs: { href: string; target: string; rel: string };
  };
};

const Component = (props: ComponentProps) => (
  <NodeViewWrapper className="mui-button">
    <MuiButton
      href={props.node.attrs.href}
      target={props.node.attrs.target}
      rel={props.node.attrs.rel}
      variant="contained"
    >
      <NodeViewContent />
    </MuiButton>
  </NodeViewWrapper>
);

type ButtonOptions = {
  HTMLAttributes: Record<string, string>;
};

export const Button = Node.create<ButtonOptions>({
  name: 'mui-button',
  group: 'block',

  defining: true,

  content: 'inline*',
  addOptions() {
    return {
      HTMLAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow',
      },
    };
  },
  parseHTML() {
    return [{ tag: 'mui-button' }];
  },

  addAttributes() {
    return {
      href: {
        default: null,
      },
      target: {
        default: this.options.HTMLAttributes.target,
      },
      rel: {
        default: this.options.HTMLAttributes.rel,
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'mui-button',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },
  addCommands() {
    return {
      setButton:
        ({ href }) =>
        ({ commands }) =>
          commands.setNode(this.name, { href }),
      unsetButton:
        () =>
        ({ commands }) =>
          commands.clearNodes(),
    };
  },
  addNodeView() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return ReactNodeViewRenderer(Component as any);
  },
});
